var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { colors, cssThemedValue, cssVarsThemed, semanticColors } from '@creditornot/cb-ingredients';
import { createCssVarDefinitions, createCssVars, themedConfigToThemedAttrs, } from '@creditornot/cb-utils';
var cssVars = createCssVars(['size', 'iconSize', 'width', 'borderRadius']);
var variantCssVars = createCssVars([
    'bg',
    'bgHover',
    'bgActive',
    'bgDisabled',
    'iconFill',
    'iconFillHover',
    'iconFillDisabled',
]);
var variantConfigs = {
    blue: {
        static: {
            light: {
                bg: colors.wolt8,
                bgHover: colors.wolt16,
                bgActive: colors.wolt24,
                bgDisabled: colors.wolt8,
                iconFill: colors.wolt100,
                iconFillHover: colors.wolt100,
                iconFillDisabled: colors.wolt40,
            },
            dark: {
                bg: colors.wolt16,
                bgHover: colors.wolt24,
                bgActive: colors.wolt28,
                bgDisabled: colors.wolt20,
                iconFill: colors.wolt100,
                iconFillHover: colors.wolt100,
                iconFillDisabled: colors.wolt48,
            },
        },
        staticWhite: {
            light: {
                bg: semanticColors.light.surfaceMain,
                bgHover: colors.wolt8,
                bgActive: colors.wolt16,
                bgDisabled: semanticColors.light.surfaceMain,
                iconFill: colors.wolt100,
                iconFillHover: colors.wolt100,
                iconFillDisabled: colors.wolt40,
            },
            dark: {
                bg: semanticColors.dark.surfaceMain,
                bgHover: colors.wolt24,
                bgActive: colors.wolt28,
                bgDisabled: semanticColors.dark.surfaceMain,
                iconFill: colors.wolt100,
                iconFillHover: colors.wolt100,
                iconFillDisabled: colors.wolt52,
            },
        },
        animated: {
            light: {
                bg: colors.wolt8,
                bgHover: colors.wolt8,
                bgActive: colors.wolt16,
                bgDisabled: 'transparent',
                iconFill: colors.wolt100,
                iconFillHover: colors.wolt100,
                iconFillDisabled: colors.wolt40,
            },
            dark: {
                bg: colors.wolt16,
                bgHover: colors.wolt16,
                bgActive: colors.wolt24,
                bgDisabled: 'transparent',
                iconFill: colors.wolt100,
                iconFillHover: colors.wolt100,
                iconFillDisabled: colors.wolt52,
            },
        },
    },
    black: {
        static: {
            light: {
                bg: colors.pepper8,
                bgHover: colors.pepper16,
                bgActive: colors.pepper24,
                bgDisabled: colors.pepper8,
                iconFill: colors.pepper100,
                iconFillHover: colors.pepper100,
                iconFillDisabled: colors.pepper40,
            },
            dark: {
                bg: colors.salt12,
                bgHover: colors.salt20,
                bgActive: colors.salt28,
                bgDisabled: colors.salt12,
                iconFill: colors.salt100,
                iconFillHover: colors.salt100,
                iconFillDisabled: colors.salt44,
            },
        },
        staticWhite: {
            light: {
                bg: colors.salt100,
                bgHover: colors.pepper8,
                bgActive: colors.pepper16,
                bgDisabled: colors.salt100,
                iconFill: colors.pepper100,
                iconFillHover: colors.pepper100,
                iconFillDisabled: colors.pepper40,
            },
            dark: {
                bg: semanticColors.dark.surfaceMain,
                bgHover: colors.salt12,
                bgActive: colors.salt20,
                bgDisabled: semanticColors.dark.surfaceMain,
                iconFill: colors.salt100,
                iconFillHover: colors.salt100,
                iconFillDisabled: colors.salt44,
            },
        },
        animated: {
            light: {
                bg: colors.pepper8,
                bgHover: colors.pepper8,
                bgActive: colors.pepper16,
                bgDisabled: 'transparent',
                iconFill: colors.pepper100,
                iconFillHover: colors.pepper100,
                iconFillDisabled: colors.pepper40,
            },
            dark: {
                bg: colors.salt12,
                bgHover: colors.salt12,
                bgActive: colors.salt20,
                bgDisabled: 'transparent',
                iconFill: colors.salt100,
                iconFillHover: colors.salt100,
                iconFillDisabled: colors.salt44,
            },
        },
    },
    grey: {
        static: {
            light: {
                bg: colors.pepper8,
                bgHover: colors.pepper16,
                bgActive: colors.pepper24,
                bgDisabled: colors.pepper8,
                iconFill: colors.pepper64,
                iconFillHover: colors.pepper80,
                iconFillDisabled: colors.pepper40,
            },
            dark: {
                bg: colors.salt12,
                bgHover: colors.salt20,
                bgActive: colors.salt28,
                bgDisabled: colors.salt12,
                iconFill: colors.salt72,
                iconFillHover: colors.salt92,
                iconFillDisabled: colors.salt48,
            },
        },
        staticWhite: {
            light: {
                bg: semanticColors.light.surfaceMain,
                bgHover: colors.pepper8,
                bgActive: colors.pepper16,
                bgDisabled: semanticColors.light.surfaceMain,
                iconFill: colors.pepper64,
                iconFillHover: colors.pepper88,
                iconFillDisabled: colors.pepper40,
            },
            dark: {
                bg: semanticColors.dark.surfaceMain,
                bgHover: colors.salt20,
                bgActive: colors.salt28,
                bgDisabled: semanticColors.dark.surfaceMain,
                iconFill: colors.salt76,
                iconFillHover: colors.salt92,
                iconFillDisabled: colors.salt52,
            },
        },
        animated: {
            light: {
                bg: colors.pepper8,
                bgHover: colors.pepper8,
                bgActive: colors.pepper16,
                bgDisabled: colors.pepper4,
                iconFill: colors.pepper64,
                iconFillHover: colors.pepper88,
                iconFillDisabled: colors.pepper40,
            },
            dark: {
                bg: colors.salt12,
                bgHover: colors.salt12,
                bgActive: colors.salt20,
                bgDisabled: colors.salt8,
                iconFill: colors.salt68,
                iconFillHover: colors.salt92,
                iconFillDisabled: colors.salt44,
            },
        },
    },
    lightGrey: {
        static: {
            light: {
                bg: colors.pepper4,
                bgHover: colors.pepper8,
                bgActive: colors.pepper16,
                bgDisabled: colors.pepper4,
                iconFill: colors.pepper52,
                iconFillHover: colors.pepper76,
                iconFillDisabled: colors.pepper36,
            },
            dark: {
                bg: colors.salt8,
                bgHover: colors.salt12,
                bgActive: colors.salt20,
                bgDisabled: colors.salt8,
                iconFill: colors.salt56,
                iconFillHover: colors.salt80,
                iconFillDisabled: colors.salt40,
            },
        },
        staticWhite: {
            light: {
                bg: semanticColors.light.surfaceMain,
                bgHover: colors.pepper4,
                bgActive: colors.pepper12,
                bgDisabled: semanticColors.light.surfaceMain,
                iconFill: colors.pepper52,
                iconFillHover: colors.pepper76,
                iconFillDisabled: colors.pepper36,
            },
            dark: {
                bg: semanticColors.dark.surfaceMain,
                bgHover: colors.salt16,
                bgActive: colors.salt16,
                bgDisabled: semanticColors.dark.surfaceMain,
                iconFill: colors.salt60,
                iconFillHover: colors.salt84,
                iconFillDisabled: colors.salt44,
            },
        },
        animated: {
            light: {
                bg: colors.pepper4,
                bgHover: colors.pepper4,
                bgActive: colors.pepper12,
                bgDisabled: colors.pepper4,
                iconFill: colors.pepper52,
                iconFillHover: colors.pepper76,
                iconFillDisabled: colors.pepper36,
            },
            dark: {
                bg: colors.salt16,
                bgHover: colors.salt16,
                bgActive: colors.salt24,
                bgDisabled: colors.salt16,
                iconFill: colors.salt60,
                iconFillHover: colors.salt84,
                iconFillDisabled: colors.salt44,
            },
        },
    },
    white: {
        static: {
            light: {
                bg: colors.salt8,
                bgHover: colors.salt16,
                bgActive: colors.salt24,
                bgDisabled: colors.salt8,
                iconFill: colors.salt100,
                iconFillHover: colors.salt100,
                iconFillDisabled: colors.salt40,
            },
            dark: {
                bg: colors.space8,
                bgHover: colors.space16,
                bgActive: colors.space24,
                bgDisabled: colors.space8,
                iconFill: colors.space100,
                iconFillHover: colors.space100,
                iconFillDisabled: colors.space40,
            },
        },
        staticWhite: {
            light: {
                bg: semanticColors.light.surfaceMain,
                bgHover: colors.salt8,
                bgActive: colors.salt16,
                bgDisabled: semanticColors.light.surfaceMain,
                iconFill: semanticColors.light.surfaceMain,
                iconFillHover: semanticColors.light.surfaceMain,
                iconFillDisabled: colors.salt40,
            },
            dark: {
                bg: semanticColors.dark.surfaceMain,
                bgHover: colors.space8,
                bgActive: colors.space16,
                bgDisabled: semanticColors.dark.surfaceMain,
                iconFill: semanticColors.dark.surfaceMain,
                iconFillHover: semanticColors.dark.surfaceMain,
                iconFillDisabled: colors.space40,
            },
        },
        animated: {
            light: {
                bg: colors.salt8,
                bgHover: colors.salt8,
                bgActive: colors.salt16,
                bgDisabled: 'transparent',
                iconFill: colors.salt100,
                iconFillHover: colors.salt100,
                iconFillDisabled: colors.salt40,
            },
            dark: {
                bg: colors.space8,
                bgHover: colors.space8,
                bgActive: colors.space16,
                bgDisabled: 'transparent',
                iconFill: colors.space100,
                iconFillHover: colors.space100,
                iconFillDisabled: colors.space40,
            },
        },
    },
    red: {
        static: {
            light: {
                bg: colors.strawberry8,
                bgHover: colors.strawberry16,
                bgActive: colors.strawberry24,
                bgDisabled: colors.strawberry8,
                iconFill: colors.strawberry100,
                iconFillHover: colors.strawberry100,
                iconFillDisabled: colors.strawberry40,
            },
            dark: {
                bg: colors.strawberry16,
                bgHover: colors.strawberry20,
                bgActive: colors.strawberry24,
                bgDisabled: colors.strawberry20,
                iconFill: colors.strawberry100,
                iconFillHover: colors.strawberry100,
                iconFillDisabled: colors.strawberry48,
            },
        },
        staticWhite: {
            light: {
                bg: semanticColors.light.surfaceMain,
                bgHover: colors.strawberry8,
                bgActive: colors.strawberry16,
                bgDisabled: semanticColors.light.surfaceMain,
                iconFill: colors.strawberry100,
                iconFillHover: colors.strawberry100,
                iconFillDisabled: colors.strawberry40,
            },
            dark: {
                bg: semanticColors.dark.surfaceMain,
                bgHover: colors.strawberry20,
                bgActive: colors.strawberry24,
                bgDisabled: semanticColors.dark.surfaceMain,
                iconFill: colors.strawberry100,
                iconFillHover: colors.strawberry100,
                iconFillDisabled: colors.strawberry52,
            },
        },
        animated: {
            light: {
                bg: colors.strawberry8,
                bgHover: colors.strawberry8,
                bgActive: colors.strawberry16,
                bgDisabled: 'transparent',
                iconFill: colors.strawberry100,
                iconFillHover: colors.strawberry100,
                iconFillDisabled: colors.strawberry40,
            },
            dark: {
                bg: colors.strawberry16,
                bgHover: colors.strawberry16,
                bgActive: colors.strawberry24,
                bgDisabled: 'transparent',
                iconFill: colors.strawberry100,
                iconFillHover: colors.strawberry100,
                iconFillDisabled: colors.strawberry52,
            },
        },
    },
};
var sizes = {
    tiny: 24,
    small: 36,
};
var BG = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  --absPos: ", ";\n  position: absolute;\n  top: var(--absPos);\n  right: var(--absPos);\n  bottom: var(--absPos);\n  left: var(--absPos);\n  overflow: hidden;\n  width: ", ";\n  height: ", ";\n  border-radius: ", ";\n\n  transition: transform 96ms ease-in;\n  z-index: 1;\n"], ["\n  --absPos: ", ";\n  position: absolute;\n  top: var(--absPos);\n  right: var(--absPos);\n  bottom: var(--absPos);\n  left: var(--absPos);\n  overflow: hidden;\n  width: ", ";\n  height: ", ";\n  border-radius: ", ";\n\n  transition: transform 96ms ease-in;\n  z-index: 1;\n"])), function (_a) {
    var $alignment = _a.$alignment;
    return $alignment === 'boundingBox' ? 0 : "calc(-1 * (".concat(cssVars.size, " - ").concat(cssVars.iconSize, ") / 2)");
}, cssVars.size, cssVars.size, cssVars.borderRadius);
var IconContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  overflow: hidden;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  overflow: hidden;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var Root = styled.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n\n  ", "\n\n\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  box-sizing: border-box;\n  outline: none;\n\n  position: relative;\n  flex-shrink: 0;\n  z-index: 0;\n\n  width: ", ";\n  height: ", ";\n  border-radius: ", ";\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  &:not(:disabled) {\n    cursor: pointer;\n  }\n\n  &:not(:disabled) svg {\n    fill: ", ";\n  }\n\n  ", " {\n    background-color: ", ";\n    transform: ", ";\n  }\n\n  &:disabled ", " {\n    background-color: ", ";\n  }\n\n  &:hover:not(:disabled) {\n    ", " {\n      background-color: ", ";\n      transform: scale(1);\n    }\n\n    svg {\n      fill: ", ";\n    }\n  }\n\n  &:active:not(:disabled) ", " {\n    background-color: ", ";\n  }\n  &:disabled svg {\n    fill: ", ";\n  }\n\n  &:focus-visible ", " {\n    box-shadow: 0 0 0 3px ", ";\n    transform: scale(1);\n  }\n\n  svg {\n    transition: fill 96ms ease-in;\n    width: ", ";\n    height: ", ";\n  }\n"], ["\n  ", "\n\n  ", "\n\n\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  box-sizing: border-box;\n  outline: none;\n\n  position: relative;\n  flex-shrink: 0;\n  z-index: 0;\n\n  width: ", ";\n  height: ", ";\n  border-radius: ", ";\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  &:not(:disabled) {\n    cursor: pointer;\n  }\n\n  &:not(:disabled) svg {\n    fill: ", ";\n  }\n\n  ", " {\n    background-color: ", ";\n    transform: ", ";\n  }\n\n  &:disabled ", " {\n    background-color: ", ";\n  }\n\n  &:hover:not(:disabled) {\n    ", " {\n      background-color: ", ";\n      transform: scale(1);\n    }\n\n    svg {\n      fill: ", ";\n    }\n  }\n\n  &:active:not(:disabled) ", " {\n    background-color: ", ";\n  }\n  &:disabled svg {\n    fill: ", ";\n  }\n\n  &:focus-visible ", " {\n    box-shadow: 0 0 0 3px ", ";\n    transform: scale(1);\n  }\n\n  svg {\n    transition: fill 96ms ease-in;\n    width: ", ";\n    height: ", ";\n  }\n"])), function (_a) {
    var $alignment = _a.$alignment, $cssVarOverrides = _a.$cssVarOverrides, $size = _a.$size;
    return createCssVarDefinitions(__assign(__assign({ size: "".concat(sizes[$size], "px"), borderRadius: '50%' }, $cssVarOverrides), { iconSize: "calc(".concat(cssVars.size, " / 2)"), width: $alignment === 'boundingBox' ? cssVars.size : "calc(".concat(cssVars.size, " / 2)") }));
}, function (_a) {
    var $background = _a.$background, $variant = _a.$variant;
    return cssVarsThemed(themedConfigToThemedAttrs(variantConfigs[$variant][$background]));
}, cssVars.width, cssVars.width, cssVars.borderRadius, variantCssVars.iconFill, BG, variantCssVars.bg, function (_a) {
    var $background = _a.$background;
    return ($background !== 'animated' ? 'scale(1)' : 'scale(0)');
}, BG, variantCssVars.bgDisabled, BG, variantCssVars.bgHover, variantCssVars.iconFillHover, BG, variantCssVars.bgActive, variantCssVars.iconFillDisabled, BG, cssThemedValue('a11yFocusIndicator'), cssVars.iconSize, cssVars.iconSize);
var IconButton = React.forwardRef(function (_a, ref) {
    var _b = _a.alignment, alignment = _b === void 0 ? 'boundingBox' : _b, _c = _a.background, background = _c === void 0 ? 'static' : _c, icon = _a.children, cssVarOverrides = _a.cssVarOverrides, _d = _a.size, size = _d === void 0 ? 'small' : _d, _e = _a.type, type = _e === void 0 ? 'button' : _e, _f = _a.variant, variant = _f === void 0 ? 'blue' : _f, rest = __rest(_a, ["alignment", "background", "children", "cssVarOverrides", "size", "type", "variant"]);
    return (React.createElement(Root, __assign({ "$alignment": alignment, "$background": background, "$cssVarOverrides": cssVarOverrides, "$size": size, "$variant": variant, type: type }, rest, { ref: ref }),
        React.createElement(BG, { "$alignment": alignment }),
        React.createElement(IconContainer, null, icon)));
});
IconButton.displayName = 'IconButton';
export default IconButton;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=IconButton.js.map